import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box, Typography } from "@mui/material";
import { IRiskPageFilterLists, IRiskPageFilterState } from "./RiskPageUtils";
import { IRiskSettingEdit } from "source/models/riskSetting/riskSettingEdit";
import { IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { HtmlReportPanel } from "./HtmlReportPanel";

interface IRiskPageReportHtmlFilterConditionProp extends IRiskPageFilterLists, IRiskPageFilterState {
    isPrinting: boolean;
    settings: IRiskSettingEdit;
}

export const RiskPageReportHtmlFilterCondition = (props: IRiskPageReportHtmlFilterConditionProp) => {
    return (
        <Box sx={{ marginBottom: 2 }}>
            <HtmlReportPanel
                title={Translations.FilterCondition}
                height={props.isPrinting ? "auto" : undefined}
                isPrinting={props.isPrinting}
            >
                <Box sx={{ marginTop: ".5rem" }}>
                    <Typography variant="caption" color="text.secondary">
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "0 8px" }}>
                            <Box>{`${Translations.AType}: ${IdTitle.getTitlesByIds(props.riskTypes, props.selectedRiskTypeIds)}`}</Box>
                            <Box>{`${Translations.State}: ${IdTitle.getTitlesByIds(props.states, props.selectedStateIds)}`}</Box>
                            <Box>{`${Translations.Unit}: ${IdTitleNode.getTitlesByIds(props.units, props.selectedUnitIds)}`}</Box>
                            <Box>{`${Translations.RiskCategory}: ${IdTitleNode.getTitlesByIds(props.riskCategories, props.selectedRiskCategoryIds)}`}</Box>
                            <Box>{`${Translations.RiskOwner}: ${IdTitle.getTitlesByIds(props.owners, props.selectedOwners)}`}</Box>
                            {!!props.settings?.riskStandardInUse &&
                                <Box>{`${Translations.RiskStandard}: ${IdTitleNode.getTitlesByIds(props.riskStandards, props.selectedRiskStandardIds)}`}</Box>
                            }
                            {!!props.settings?.riskStakeholderInUse &&
                                <Box>{`${Translations.RiskStakeholder}: ${IdTitleNode.getTitlesByIds(props.riskStakeholders, props.selectedRiskStakeholderIds)}`}</Box>
                            }
                            {!!props.settings?.riskProcessInUse &&
                                <Box>{`${Translations.RiskProcess}: ${IdTitleNode.getTitlesByIds(props.riskProcesses, props.selectedRiskProcessIds)}`}</Box>
                            }
                            <Box>{`${Translations.ResidualRisk}: ${IdTitle.getTitlesByIds(props.residualRisks, props.selectedResidualRiskIds)}`}</Box>
                            <Box>{`${Translations.PersonInCharge}: ${IdTitle.getTitlesByIds(props.handlers, props.selectedHandlerUserCodes)}`}</Box>
                            <Box>{`${Translations.RiskTreatmentState}: ${IdTitle.getTitlesByIds(props.riskTreatmentStates, props.selectedRiskTreatmentStateIds)}`}</Box>
                        </Box>
                    </Typography>
                </Box>
            </HtmlReportPanel>
        </Box>
    );
};
